import { render } from "./ReLoginModal.vue?vue&type=template&id=6d995470"
import script from "./ReLoginModal.vue?vue&type=script&lang=js"
export * from "./ReLoginModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__